export default __webpack_public_path__ + "static/media/family.747fe11d.png";